import {
  useI18N,
} from "common/hooks";

import Loader from "@/components/common/Loader";
import { XIcon } from "lucide-react";
import { useDarkMode } from "@/hooks/useDarkMode";


function SelectAddNoteType(props: {
  onClose: () => void;
  onMapperNoteClick: () => void;
  onVenueNoteClick: () => void;
}) {
  const i18n = useI18N();
  const isDark = useDarkMode();

  return (
    <>
      <section
        className="flex flex-col bg-white dark:bg-primary-900 rounded-xl  overflow-y-auto"
        role="none"
      >
        {status === "pending" && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-[250px] z-50">
            <Loader />
          </div>
        )}

        <header className="py-4 min-h-14 flex items-center justify-center text-center px-6 border-b border-primary-200 dark:border-primary-150 vsticky top-0">
          <h1
            className="mobile-h1-xsmall-bold text-center text-primary-800 dark:text-primary-150"
            tabIndex={0}
          >
            {i18n.get("createNote")}
          </h1>
          <button
            onClick={props.onClose}
            className="absolute top-4 left-4"
            aria-label="Close modal"
          >
            <XIcon color={isDark ? "#A39FE8" : "#352FC3"} />
          </button>
        </header>

        <div
          aria-label="Modal Content"
          className="flex-grow overflow-y-auto py-3"
          role="none"
        >
          <div className="self-stretch flex-col justify-start items-center gap-2 flex">
            <div 
              id="mapperNote" 
              className="self-stretch px-6 py-2 rounded-lg inline-flex justify-start items-center gap-6 flex-wrap content-center overflow-hidden cursor-pointer"
              onClick={props.onMapperNoteClick}
            >
              <div data-weight="Regular" className="w-6 h-6 relative">
                <div className="w-6 h-6 left-[2.25px] top-[3px] absolute bg-Bottom-Sheet-Primary-Icon-generic">
                  <img
                    src={
                      isDark
                        ? "/images/CreateMapperNoteWhite.svg"
                        : "/images/CreateMapperNote.svg"
                    }
                    alt=""
                    aria-hidden="true"
                  />
                </div>
              </div>
              <div className="h-14 inline-flex flex-col justify-center items-start gap-1">
                <div className="self-stretch text-primary-800 dark:text-primary-150 mobile-h3-small-bold">
                  {i18n.get("mapperNote")}
                </div>
                <div className="self-stretch text-neutral-700 dark:text-primary-150 paragraph-small-regular">
                  {i18n.get("thisWillBeOnlyVisibleToTheTeam")}
                </div>
              </div>
            </div>

            <div className="border w-full border-primary-150 dark:border-neutral-400 mt-2 h-[1px]"></div>

            <div 
              id="venueNote" 
              className="self-stretch px-6 py-2 rounded-lg inline-flex justify-start items-center gap-6 flex-wrap content-center overflow-hidden cursor-pointer"
              onClick={props.onVenueNoteClick}
            >
              <div
                data-format="Outline"
                data-weight="Regular"
                className="w-6 h-6 relative"
              >
                <div className="w-6 h-6 left-[2.25px] top-[3px] absolute bg-Bottom-Sheet-Primary-Icon-generic">
                  <img
                    src={
                      isDark
                        ? "/images/CreateVenueNoteWhite.svg"
                        : "/images/CreateVenueNote.svg"
                    }
                    alt=""
                    aria-hidden="true"
                  />
                </div>
              </div>
              <div className="h-14 inline-flex flex-col justify-center items-start gap-1">
                <div className="self-stretch text-primary-800 dark:text-primary-150 mobile-h3-small-bold">
                  {i18n.get("venueNote")}
                </div>
                <div className="self-stretch text-neutral-700 dark:text-primary-150 paragraph-small-regular">
                  {i18n.get("thisNoteWillBeVisibleToEveryone")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SelectAddNoteType;
